import React from 'react'
import { Box,Text,Image,Container,Center, Heading,VStack,Select } from '@chakra-ui/react'
import Fotter from './Fotter'
const Home = () => {
  return (
    <div>
      <Box>
       <Image src="https://www.zoomcar.com/img/background.png" alt='HomeBanner'/>
      </Box>
      <Box>
       <Container>
         <Center>
        <VStack>
        <Text as="h3" style={{fontSize:'24px', fontWeight:"400"}} >
         Oops! Looks like we don’t serve in your city
         </Text>
         <Heading>
         Select a different Location
         </Heading>
         <Box>
         <Select placeholder='INDIA' size={"lg"} width={"500px"}>
      <option value='option1'>Delhi</option>
     <option value='option2'>Bangalore</option>
      <option value='option3'>Chennai</option>
      <option value='option3'>Ahmedabad</option>
      <option value='option3'>Mangalore</option>
      <option value='option3'>Nagpur</option>
      <option value='option3'>Bhopal</option>
      <option value='option3'>Vadodara</option>
      <option value='option3'>Madurai</option>
      <option value='option3'>Pune</option>
      <option value='option3'>Coimbatore</option>
      <option value='option3'>Delhi NCR</option>
      <option value='option3'>Vijayawada</option>
      <option value='option3'>Udupi-Manipal</option>
      <option value='option3'>Hyderabad</option>
       </Select>
         </Box>
        </VStack>
         

         </Center>
       </Container>
      </Box>

      
    </div>
  )
}

export default Home